import { createAction, props } from '@ngrx/store';

export const getVehicleAverageComsuptionList = createAction('[Dashboard] Get All Vehicle Average Comsuption List Action',
    props<{ options: any }>()); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadVehicleAverageComsuptiontList = createAction('[Dashboard] Load All Vehicle Average Comsuption List Action',
    props<{ response: any }>());
    export const getTransactionsList = createAction('[Dashboard] Get All Transactions List Action',
    props<{ options: any }>()); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadTransactionsList = createAction('[Dashboard] Load All Transactions List Action',
    props<{ response: any }>());

export const getLoadingState = createAction('[Dashboard] Get Dashboard Loading State Action');
export const setLoadingStartState = createAction('[Dashboard] Set Dashboard Loading Start State Action');
export const setLoadingEndState = createAction('[Dashboard] Set Dashboard Loading End State Action');